import { render, staticRenderFns } from "./VendorBillingsList.vue?vue&type=template&id=fe8970b4&scoped=true&"
import script from "./VendorBillingsList.vue?vue&type=script&lang=js&"
export * from "./VendorBillingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8970b4",
  null
  
)

export default component.exports